var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"br-empty-banner"},[_c('img',{staticClass:"br-empty-banner-icon",attrs:{"src":_vm.iconUrl,"width":"20","height":"20","alt":""}}),_c('p',{staticClass:"br-empty-banner-text"},[_vm._v(" "+_vm._s(_vm.$t(_vm.messageKey))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }